module.exports = __webpack_public_path__ + "static/media/sort-right-solid-white.69f02d3a.svg";